import axios from "axios";

// const REST_API_BASE_URL="http://localhost:9090/login_validate";

// export const loggin =(empData)=> axios.post(REST_API_BASE_URL, empData);

const API_URL = `${process.env.REACT_APP_URL}/auth/`;

axios.defaults.withCredentials = true; // Important for CORS with credentials

const authService = {
  login: async ({ username, password, captcha }) => {
    try {
      const response = await axios.post(API_URL + "login", {
        username,
        password,
        captcha,
      });
      console.log("response from the server", response);

      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  logout: () => {
    sessionStorage.clear();
    localStorage.clear();
  },

  getCurrentUser: () => {
    return JSON.parse(localStorage.getItem("person"));
  },
  changePassword: async ({ username, password, captcha, newPassword }) => {
    try {
      const response = await axios.post(
        API_URL + "first-time-login-reset-pass",
        {
          username,
          password,
          captcha,
          newPassword,
        }
      );
      console.log("response from the server", response);

      return response.data;
    } catch (error) {
      console.log("Error::: ", error);
      throw error;
    }
  },
  changeNicUserPassword: async ({
    username,
    password,
    captcha,
    newPassword,
  }) => {
    try {
      const response = await axios.post(
        API_URL + "nic-user-first-time-login-reset-pass",
        {
          username,
          password,
          captcha,
          newPassword,
        }
      );
      console.log("response from the server", response);

      return response.data;
    } catch (error) {
      console.log("Error::: ", error);
      throw error;
    }
  },
};

export default authService;
